<template>
    <UiTextHtml id="UiGeneralText" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>
